import _defineProperty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _createForOfIteratorHelper from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React, { forwardRef } from 'react';
import { useComponentDefaultProps } from '@mantine/styles';
import { createPolymorphicComponent } from '@mantine/utils';
import { InputWrapper } from './InputWrapper/InputWrapper.js';
import { InputDescription } from './InputDescription/InputDescription.js';
import { InputLabel } from './InputLabel/InputLabel.js';
import { InputError } from './InputError/InputError.js';
import { InputPlaceholder } from './InputPlaceholder/InputPlaceholder.js';
import { useInputWrapperContext } from './InputWrapper.context.js';
import useStyles from './Input.styles.js';
import { extractSystemStyles } from '../Box/style-system-props/extract-system-styles/extract-system-styles.js';
import { Box } from '../Box/Box.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var defaultProps = {
  rightSectionWidth: 36,
  size: "sm",
  variant: "default"
};
var _Input = forwardRef(function (props, ref) {
  var _cx;
  var _a = useComponentDefaultProps("Input", defaultProps, props),
    className = _a.className,
    invalid = _a.invalid,
    required = _a.required,
    disabled = _a.disabled,
    variant = _a.variant,
    icon = _a.icon,
    style = _a.style,
    rightSectionWidth = _a.rightSectionWidth,
    iconWidth = _a.iconWidth,
    rightSection = _a.rightSection,
    rightSectionProps = _a.rightSectionProps,
    radius = _a.radius,
    size = _a.size,
    wrapperProps = _a.wrapperProps,
    classNames = _a.classNames,
    styles = _a.styles,
    __staticSelector = _a.__staticSelector,
    multiline = _a.multiline,
    sx = _a.sx,
    unstyled = _a.unstyled,
    pointer = _a.pointer,
    others = __objRest(_a, ["className", "invalid", "required", "disabled", "variant", "icon", "style", "rightSectionWidth", "iconWidth", "rightSection", "rightSectionProps", "radius", "size", "wrapperProps", "classNames", "styles", "__staticSelector", "multiline", "sx", "unstyled", "pointer"]);
  var _useInputWrapperConte = useInputWrapperContext(),
    offsetBottom = _useInputWrapperConte.offsetBottom,
    offsetTop = _useInputWrapperConte.offsetTop,
    describedBy = _useInputWrapperConte.describedBy;
  var _useStyles = useStyles({
      radius: radius,
      size: size,
      multiline: multiline,
      variant: variant,
      invalid: invalid,
      rightSectionWidth: rightSectionWidth,
      iconWidth: iconWidth,
      withRightSection: !!rightSection,
      offsetBottom: offsetBottom,
      offsetTop: offsetTop,
      pointer: pointer
    }, {
      classNames: classNames,
      styles: styles,
      name: ["Input", __staticSelector],
      unstyled: unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _extractSystemStyles = extractSystemStyles(others),
    systemStyles = _extractSystemStyles.systemStyles,
    rest = _extractSystemStyles.rest;
  return /* @__PURE__ */React.createElement(Box, __spreadValues(__spreadValues({
    className: cx(classes.wrapper, className),
    sx: sx,
    style: style
  }, systemStyles), wrapperProps), icon && /* @__PURE__ */React.createElement("div", {
    className: classes.icon
  }, icon), /* @__PURE__ */React.createElement(Box, __spreadProps(__spreadValues({
    component: "input"
  }, rest), {
    ref: ref,
    required: required,
    "aria-invalid": invalid,
    "aria-describedby": describedBy,
    disabled: disabled,
    className: cx(classes["".concat(variant, "Variant")], classes.input, (_cx = {}, _defineProperty(_cx, classes.withIcon, icon), _defineProperty(_cx, classes.invalid, invalid), _defineProperty(_cx, classes.disabled, disabled), _cx))
  })), rightSection && /* @__PURE__ */React.createElement("div", __spreadProps(__spreadValues({}, rightSectionProps), {
    className: classes.rightSection
  }), rightSection));
});
_Input.displayName = "@mantine/core/Input";
_Input.Wrapper = InputWrapper;
_Input.Label = InputLabel;
_Input.Description = InputDescription;
_Input.Error = InputError;
_Input.Placeholder = InputPlaceholder;
var Input = createPolymorphicComponent(_Input);
export { Input, _Input };